import { render, staticRenderFns } from "./EquipamentoStatusCard.vue?vue&type=template&id=01262597&scoped=true&"
import script from "./EquipamentoStatusCard.vue?vue&type=script&lang=js&"
export * from "./EquipamentoStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoStatusCard.vue?vue&type=style&index=0&id=01262597&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01262597",
  null
  
)

export default component.exports